export default __webpack_public_path__ + "static/bg-4-38bd2fdc718b2dcf99435a2fac8e0e32.jpg";